/**
 * PaymentFormDialog
 *
 * Opens the "Novo Lançamento" form (from /financeiro/relacao-pagamentos/novo)
 * as a large full-screen-ish modal dialog.
 */

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogClose,
} from "@/components/ui/dialog";
import { X } from "lucide-react";
import FormRelacaoPagamentos from "@/pages/relacao-pagamentos/components/form-relacao-pagamentos";
import { IProject } from "@/interfaces/project.interface";

interface PaymentFormDialogProps {
  open: boolean;
  onClose: () => void;
  projetoSelecionado: IProject | null;
  projects: { id: string; name: string, salic_number: string }[];
}

export function PaymentFormDialog({
  open,
  onClose,
  projetoSelecionado,
  projects,
}: PaymentFormDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-4xl w-full bg-[#15203C] border-[#7846FF] rounded-[20px] p-0 overflow-y-auto max-h-[90vh]">
        <div className="px-8 pb-8 pt-4">
          <FormRelacaoPagamentos
            projetoSelecionado={projetoSelecionado}
            projects={projects}
            onClose={onClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
